import { httpApi } from '@nucleus-care/nucleuscare-backend-client';
import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

import { UIModal } from '../../../components/UI';
import { ModalAction } from '../../../components/UI/Modals/Base/ActionButtons';
import Message from '../../../utils/Message';
import { Group, GroupCategory } from './types';

const Title = styled.p`
  color: #f00;
  font-size: 64px;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  margin: 0;
`;

const Note = styled.p`
  color: #0a313f;
  text-align: center;
  font-size: 20px;
`;

const Name = styled.p`
  color: #0a313f;
  text-align: center;
  font-weight: 600;
  font-size: 24px;
`;

const Groups = styled.p`
  color: #0a313f;
  text-align: center;
  font-size: 20px;
`;

const Text = styled.p`
  margin: 0;
`;

const BoldText = styled.p`
  font-weight: 600;
`;
const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
`;

interface Props {
  closeModal: () => void;
  isOpen: boolean;
  category?: GroupCategory | null;
}

type PreviewData = {
  totalGroups: number;
  totalPatientsInGroups: number;
  groups: Group[];
};

const DeleteGroupCategory: FC<Props> = ({ closeModal, isOpen, category }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<PreviewData>();

  useEffect(() => {
    if (category) {
      getPreviewData();
    }
  }, [category]);

  const deleteGroupCategory = () => {
    httpApi
      .delete(`/groupCategories/${category?.id}`)
      .then(() => {
        Message.show('Group Category deleted');
        closeModal();
      })
      .catch(() => {
        Message.show('Error deleting Group Category');
        setIsLoading(false);
      });
  };

  const getPreviewData = () => {
    httpApi
      .get(`/groupCategories/${category?.id}/deletePreview`)
      .then(({ data }: { data: PreviewData }) => {
        setData(data);
      })
      .catch(() => {
        Message.show('Error getting preview data for Group Category');
        setIsLoading(false);
      });
  };

  const submit = () => {
    deleteGroupCategory();
  };

  const getActions = () => {
    const data: ModalAction[] = [
      {
        label: 'Cancel',
        onClick: closeModal,
        buttonVariant: 'secondary',
      },
      {
        label: 'Proceed',
        onClick: submit,
        disabled: isLoading,
      },
    ];

    return data;
  };

  const renderGroups = () => {
    return <div>{category?.groups?.map(group => <div key={group.name}>{group.name}</div>)}</div>;
  };

  return (
    <UIModal size="medium" isOpen={isOpen} close={closeModal} actions={getActions()}>
      <Title>WARNING!</Title>
      <Note>You are about to delete</Note>
      <Name>{`Group Category: ${category?.name}`}</Name>

      <Note>This will affect the following:</Note>

      <Groups>
        <TextContainer>
          <BoldText>Groups:</BoldText>
          <Text>{data?.totalGroups}</Text>{' '}
        </TextContainer>
        <TextContainer>
          <BoldText>Patients:</BoldText>
          <Text>{data?.totalPatientsInGroups}</Text>
        </TextContainer>
      </Groups>
    </UIModal>
  );
};

export default DeleteGroupCategory;
